import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './action';
import { getDataFromBOU } from '../../Helpers/ApiMethodHelper';

const API_URL = process.env.REACT_APP_AUTH_SERVER_PRODUCTION;
function* getClientDataResponse() {
  try {
    const response = yield call(getDataFromBOU, `${API_URL}/organizations`);
      yield put(actions.getClientDataSuccess(response?.data));
    
  } catch (error) {
    yield put(actions.getClientDataFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.GET_CLIENT_DATA, getClientDataResponse)]);

}
